import SectionProfileCard from "./SectionProfileCard";

export default SectionProfileCard